<div class="card card-body">
  <div class="row mt-3">
    <div class="col">
      <div class="switch">
        <label>
          <input
            type="checkbox"
            [(ngModel)]="showConditionalVisible"
            (ngModelChange)="visibleConditionChanged()"
          />
          Conditionally Visible
        </label>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="showConditionalVisible">
    <div class="col">
      <div class="row mt-4">
        <div class="col-11">
          <h6>Visible if criteria is true</h6>
        </div>
      </div>
      <wm-condition-group
        [conditionSources]="conditionSources"
        [group]="layout.visibleCriteria.group"
        (conditionChanges)="
          visibleCriteriaChanged(layout.visibleCriteria.group)
        "
        *ngIf="conditionSources && layout.visibleCriteria"
      >
      </wm-condition-group>
      <wm-control-message
        [control]="form.controls['visibleCriteria']"
      ></wm-control-message>
    </div>
  </div>

  <wm-activity-details-modal
    *ngIf="newDEForm"
    [title]="activity.model.screenName + ' - New Data Entity'"
    btnText="Add New Data Entity"
    moduleId="modal-new-entity"
    btnClass="btn btn-primary"
    [form]="newDEForm"
    (saved)="saveNew()"
    (canceled)="cancelNew()"
    (opened)="loadEditor()"
    [disabled]="_workflowSvc.designerVersionMode || saving"
  >
    <wm-data-entity-editor
      *ngIf="showEditor"
      #newDEEditor
      [workflow]="workflow || _context.workflow"
      [activity]="activity"
      [form]="newDEForm"
    ></wm-data-entity-editor>
  </wm-activity-details-modal>
  <div class="mb-3 text-small">
    (Each of these components will be rendered vertically in a group)
  </div>

  <div
    cdkDropList
    [id]="dropListId"
    [cdkDropListData]="layout?.groupEntities"
    [cdkDropListConnectedTo]="connectedDropLists"
    [cdkDropListEnterPredicate]="canEnter"
    (cdkDropListDropped)="drop($event)"
    class="group-entities-list cdk-drag-container"
  >
    <div
      *ngFor="let de of columnEntities; let i = index"
      class="list-group-item p-2 group-entity-item"
      cdkDrag
      [cdkDragData]="de"
    >
      <div class="drag-handle" cdkDragHandle>
        <i class="material-icons">drag_handle</i>
      </div>
      <div class="flex-grow-1">
        <wm-data-entity-item
          #entityItem
          [de]="de"
          [workflow]="workflow"
          [activity]="activity"
          (deleteEntity)="removeDataEntity(de, i)"
          (editEntity)="viewDataEntity(de)"
          (saveEntity)="saveDataEntity(de)"
          (saveActivity)="onSaved($event)"
        >
        </wm-data-entity-item>
      </div>
    </div>
  </div>
</div>
